<template>
  <div id="app">
    <keep-aliv>
      <router-view />
    </keep-aliv>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
// @import '@/uni_modules/uview-ui/index.scss';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
